<template>
  <div class="modal modal-bg" :class="{ show: open }">
    <modal
      v-if="open"
      modal-with-card
      card-classes="md-card-login"
      type="modal-announcements"
      @close="$emit('close')"
    >
      <template #header>
        <md-card-header class="md-card-header-cyan m-0">
          <md-button
            class="md-simple md-close md-white md-just-icon md-round modal-card-button mt-10"
            @click="$emit('close')"
          >
            <md-icon class="opacity-100">clear</md-icon>
          </md-button>
          <h4 class="card-title mt-0">Release Notes</h4>
        </md-card-header>
      </template>

      <template #body>
        <div class="section pb-0">
          <div class="instruction">
            <div class="md-layout" v-if="notesLocal">
              <collapse-extended
                :collapse="notesLocal"
                icon="keyboard_arrow_down"
                color-collapse="cyan-900"
                class="md-layout-item md-size-90 mx-auto"
              />
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal, CollapseExtended } from "@/components";
import ApiAnnouncements from "@/api/methods/ApiAnnouncements";
import DateFormatter from "@/api/helpers/DateFormatter";

export default {
  name: "ModalAnnounecments",
  components: { Modal, CollapseExtended },
  props: ["open", "notes"],
  data() {
    return {
      notesLocal: null,
    };
  },

  watch: {
    notes() {
      this.notesLocal = this.notes.releaseNotes.map(function (note) {
        return {
          title: note.messageHeader,
          subtitle: DateFormatter.UTCToLongString(
            DateFormatter.strToUTC(note.dateTime)
          ),
          content: note.messageText,
        };
      });
      this.hideAnnouncements();
    },
  },
  methods: {
    hideAnnouncements() {
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$emit("close");
        return;
      }
      ApiAnnouncements.hideAnnouncements(
        token,
        this.notes.releaseNotes.map((note) => note.messageId)
      )
        .then((_) => {})
        .catch((_) => {});
    },
  },
};
</script>
